var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"notification",class:[ _vm.typeClass]},[_c('button',{staticClass:"delete",on:{"click":function($event){return _vm.close()}}}),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.message)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }